// @flow

import type { SamlSession } from '../types/samlType';
import { parseUrl, turanBaseURL } from '../utils/urlUtils';

export const SESSION_CURRENT_USER = 'apolloUser';

let currentUserObject: ?SamlSession = null;

function getToken(): string {
  return parseUrl(window.location.href).token;
}

const activeToken = getToken();
if (activeToken) {
  currentUserObject = tokenToCurrentUser(activeToken);
  localStorage.setItem(SESSION_CURRENT_USER, JSON.stringify(currentUserObject));
}

export function refreshSessionToken() {
  const currentHref = encodeURIComponent(window.location.href);
  window.location.href = `${turanBaseURL()}/saml?RelayState=${currentHref}`;
}

function parseUserFromJwtToken(jwtToken: string) {
  return JSON.parse(decodeURIComponent(escape(atob(jwtToken.split('.')[1]))));
}

export function currentUser(): ?SamlSession {
  if (currentUserObject) {
    return currentUserObject;
  }
  const currentUserSessionString = localStorage.getItem(SESSION_CURRENT_USER);
  if (!currentUserSessionString) {
    return null;
  }
  currentUserObject = JSON.parse(currentUserSessionString);
  return currentUserObject;
}

export function isUserLoggedOn() {
  return currentUser() !== null;
}

export function isCurrentUserGeminiAdmin() {
  return currentUser().activeUser.permissions.includes('GEMINI_ADMIN');
}

export function currentUserSessionToken() {
  const apolloUser = currentUser();
  if (apolloUser) {
    return apolloUser.token;
  }
  return '';
}

export function tokenToCurrentUser(token: string) {
  const currentTokenUser = parseUserFromJwtToken(token);
  return ({
    activeUser: currentTokenUser,
    exp: currentTokenUser.exp,
    token,
  });
}
